import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { TableColumn } from '../../core/models/column.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Alert } from '../../core/models/alert.model';
import { MatTabsModule } from '@angular/material/tabs';
import { GeneralComponent } from '../general/general.component';
import { Constants } from '../../shared/utils/constants';
import { UpdateRecordService } from '../../core/services/update-record.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { UpdateRecord } from '../../core/models/update-record.model';
import { ModalComponent } from '../modal/modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmPopupComponent } from '../../shared/components/confirm-popup/confirm-popup.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { catchError, firstValueFrom, forkJoin, lastValueFrom, of } from 'rxjs';
import { ShiftClosureService } from '../../core/services/shift-closure.service';
import { AuthService } from '../../core/services/auth.service';
import { ShiftClosure } from '../../core/models/shift-closure.model';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { UpdateRecordSearchDTO } from '../../core/models/search-filter.model';
import { UserService } from '../../core/services/user.service';

@Component({
  selector: 'app-historical-shift-detail',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    RouterModule,
    MatTableModule,
    MatTabsModule,
    GeneralComponent,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    ConfirmPopupComponent,
    MatSnackBarModule
  ],
  templateUrl: './historical-shift-detail.component.html',
  styleUrl: './historical-shift-detail.component.scss'
})
export class HistoricalShiftDetailComponent implements OnInit {
  @Input() shiftClosureId!: number;
  @Input() subtitle: any;
  @Input() type: any;
  shiftClosureSel!: ShiftClosure;
  hasShiftReport: boolean = false;
  alerts: Alert[] = [];
  shiftUpdates: any[] = [];
  shiftUpdatesByArea: any[] = [];
  // Secciones similares a Shift Report
  seguridadCalidadMedioAmbiente: any[] = [];
  personalData: any[] = [];
  showClonePopup = false;
  recordToClone: any | null = null;
  // UI selección de área para altas en "por área"
  areaOptions: string[] = [
    Constants.CLORURO_FERRICO,
    Constants.SALMUERA_I,
    Constants.SALMUERA_II,
    Constants.COMPRESION,
    Constants.ELECTROLIZADORES,
    Constants.SUBESTACION,
    Constants.MOVIMIENTO_PRODUCTO,
    Constants.DCS,
  ];
  selectedAreaCode: string = Constants.CLORURO_FERRICO;

  // Columnas similares a Shift Report
  generalTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Área', field: 'updateArea', width: '120px' },
    { header: 'Hora', field: 'hora', width: '100px' },
    { header: 'Novedad', field: 'novedad', width: '60%' },
  ];

  reportedBreakdownNoticeTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Área', field: 'updateArea', width: '120px' },
    { header: 'Hora', field: 'hora', width: '100px' },
    { header: 'Prioridad', field: 'prioridad', width: '100px' },
    { header: '¿Qué está mal?', field: 'que_esta_mal', width: '15%' },
    { header: '¿Qué tiene de malo?', field: 'que_tiene_de_malo', width: '15%' },
    { header: 'Debería', field: 'deberia', width: '15%' },
  ];

  workOrderTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Área', field: 'updateArea', width: '120px' },
    { header: 'N° Orden de Trabajo', field: 'n_orden', width: '140px' },
    { header: 'Fecha', field: 'fecha', isDate: true, width: '100px' },
    { header: 'Hora Inicio', field: 'hora_inicio', width: '100px' },
    { header: 'Hora Término', field: 'hora_termino', width: '100px' },
    { header: 'Hora Permiso Otorgado', field: 'hora_permiso', width: '150px' },
    { header: 'En Ejecución', field: 'en_ejecucion', width: '100px' },
    { header: 'Comentarios', field: 'comentarios', width: '30%' },
  ];

  outOfServiceTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Área', field: 'updateArea', width: '120px' },
    { header: 'Hora', field: 'hora', width: '100px' },
    { header: 'Novedad', field: 'ingrese_novedad', width: '60%' },
  ];

  shiftUpdatesTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Hora', field: 'hora', width: '100px' },
    { header: 'Tipo', field: 'tipo_novedad', width: '120px' },
    { header: 'Novedad', field: 'detalleNovedad', width: '50%' },
    { header: 'Fecha', field: 'fecha', isDate: true, width: '100px' },
  ];

  // Columnas readonly (sin checkbox)
  generalTableColumnsRO: TableColumn[] = [];
  reportedBreakdownNoticeTableColumnsRO: TableColumn[] = [];
  workOrderTableColumnsRO: TableColumn[] = [];
  outOfServiceTableColumnsRO: TableColumn[] = [];
  shiftUpdatesTableColumnsRO: TableColumn[] = [];

  // Datos por tipo (como Shift Report)
  flattenedData: { [key: string]: any[] } = {
    [Constants.NOVEDADES]: [],
    [Constants.AVISO_AVERIAS]: [],
    [Constants.OT_EJECUTADAS]: [],
    [Constants.FUERA_SERVICIO]: [],
    [Constants.SEGURIDAD]: [],
    [Constants.PERSONAL]: [],
  };

  areaNames: string[] = ['Cloruro Férrico', 'Compresión', 'DCS', 'Electrolizadores', 'Movimiento de productos', 'Salmuera I', 'Salmuera II', 'Subestación', 'Aviso de averías solicitado']
  groupedGeneralData: { [areaName: string]: any[] } = {}

  isShiftSupervisor: boolean = false
  isDCSOperator: boolean = false
  isAreaOperator: boolean = false

  constructor(
    private updateRecordService: UpdateRecordService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private shiftClosureService: ShiftClosureService,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private userService: UserService
  ) { }

  // Mostrar columnas con checkbox solo cuando el botón "Generar informe de turno" es visible
  get showSelectableColumns(): boolean {
    return true
    return !this.hasShiftReport && this.type === Constants.TIPO_CIERE_TURNO_INFORME_DIARIO;
  }

  // Mostrar sección "Novedades del turno" solo para jefe de turno
  get isJefeTurno(): boolean {
    return this.authService?.hasRole?.('novedades') ?? false;
  }

  ngOnInit(): void {

    this.isShiftSupervisor = this.authService.hasRole('novedades');
    this.isDCSOperator = this.authService.hasRole('Novedades_Operador_DCS');
    this.isAreaOperator = this.authService.hasRole('Novedades_Operador_Ferrico') || this.authService.hasRole('Novedades_Salmuera_I') || this.authService.hasRole('Novedades_Salmuera_II') || this.authService.hasRole('Novedades_Compresion') || this.authService.hasRole('Novedades_Electrolizadores') || this.authService.hasRole('Novedades_Subestacion') || this.authService.hasRole('Novedades_Movimiento_Producto');


    this.route.params.subscribe(params => {
      console.log('Parámetros de ruta recibidos:', params);
      this.shiftClosureId = +params['shiftClosureId'];
      this.subtitle = params['tipo'];
      this.type = params['codigo_tipo'];

      console.log('shiftClosureId:', this.shiftClosureId);
      console.log('subtitle (tipo):', this.subtitle);
      console.log('type (codigo_tipo):', this.type);

      // if (this.shiftClosureId) return this.loadDataWithShiftClosureId() //para turno anterior
      // if (this.isShiftSupervisor) return this.loadAndFilterByShiftSupervisor() //(JEFE DE TURNO)
      // if (this.isDCSOperator) return this.loadAndFilterByDCSOperator() //(OPERADOR DCS) 
      // if (this.isAreaOperator) return this.loadAndFilterByAreaOperator()//(OPERADOR DE ÁREA)

      if (this.shiftClosureId) {
        //this.loadData();
        this.loadData__post();
      } else {
        console.error('shiftClosureId no válido');
      }
    });
  }



  async loadData__post(): Promise<void> {


    //1.cargar datos generales
    if (this.isJefeTurno) await this.loadGeneralData()

    //2 cargar datos por areas
    await this.loadDataByArea()

    //3 obtener shiftClosure
    await this.loadShiftClosure()

    // Preparar columnas readonly
    this.generalTableColumnsRO = this.toReadOnlyColumns(this.generalTableColumns);
    this.reportedBreakdownNoticeTableColumnsRO = this.toReadOnlyColumns(this.reportedBreakdownNoticeTableColumns);
    this.workOrderTableColumnsRO = this.toReadOnlyColumns(this.workOrderTableColumns);
    this.outOfServiceTableColumnsRO = this.toReadOnlyColumns(this.outOfServiceTableColumns);
    this.shiftUpdatesTableColumnsRO = this.toReadOnlyColumns(this.shiftUpdatesTableColumns);

    this.cdr.detectChanges();
  }



  //esto es solo cuando tipo de rol es jefe de turno
  async loadGeneralData() {

    const userId = this.authService.getUserId();
    const filterSecurityType: UpdateRecordSearchDTO = {
      type: 'seguridad',
      areas: [Constants.GENERAL],
      shiftClosureId: this.shiftClosureId,
      userScopeFilters: { searchUserId: userId }
    }
    this.seguridadCalidadMedioAmbiente = await this.getPreviousShiftClosureForGeneralNewsSection(filterSecurityType) || []

    const filterPesonalType: UpdateRecordSearchDTO = {
      type: 'personal',
      areas: [Constants.GENERAL],
      shiftClosureId: this.shiftClosureId,
      userScopeFilters: { searchUserId: userId }
    }
    this.personalData = await this.getPreviousShiftClosureForGeneralNewsSection(filterPesonalType) || []
  }


  private async loadDataByArea() {
    const userId = this.authService.getUserId();

    const searchFilterDCSOperator: UpdateRecordSearchDTO = {
      type: '',
      areas: [
        Constants.CLORURO_FERRICO,
        Constants.SALMUERA_I,
        Constants.SALMUERA_II,
        Constants.COMPRESION,
        Constants.ELECTROLIZADORES,
        Constants.SUBESTACION,
        Constants.MOVIMIENTO_PRODUCTO,
        Constants.DCS,
      ],
      shiftClosureId: this.shiftClosureId,
      userScopeFilters: { searchUserId: userId }
    };

    const types: string[] = (this.type === 'turno_diario') ?
      [
        Constants.NOVEDADES,
      ]
      :
      [
        Constants.NOVEDADES,
        Constants.AVISO_AVERIAS,
        Constants.OT_EJECUTADAS,
        Constants.FUERA_SERVICIO
      ]


    types.forEach(type => {
      const filter = { ...searchFilterDCSOperator, type }
      this.getByUpdateRecordSearch(filter)
    })
  }


  private async getByUpdateRecordSearch(filter: UpdateRecordSearchDTO) {
    const type = filter.type
    try {
      const response = await firstValueFrom(this.updateRecordService.getUpdateRecordsPost(filter))
      const flattened = this.flattenData(response);
      if (type === Constants.NOVEDADES) this.groupDataByArea(flattened)
      this.flattenedData[type] = flattened.length ? flattened : [];
    } catch (error) {
      console.error('error buscarPorPOST:', error)
    }

  }

  private async getPreviousShiftClosureForGeneralNewsSection(filters: UpdateRecordSearchDTO): Promise<UpdateRecord[] | null> {
    try {
      const response: UpdateRecord[] = await firstValueFrom(this.updateRecordService.getUpdateRecordsPost(filters))
      const flattened = this.flattenData(response)
      return flattened
    } catch (err) {
      console.error('error en getPreviousShiftClosure', err)
      return null
    }
  }

  async loadShiftClosure() {
    try {
      const shiftClosure = await firstValueFrom(this.shiftClosureService.getShiftClosureById(this.shiftClosureId))
      if (shiftClosure) {
        this.hasShiftReport = shiftClosure.isReportAvailable;
        console.log('hasShiftReport establecido a:', this.hasShiftReport);
        console.log('Shift closure ID:', this.shiftClosureId, 'isReportAvailable:', shiftClosure.isReportAvailable);
      }
    } catch (err) {
      console.error(err)
    }
  }


  loadData(): void {
    const general$ = this.updateRecordService
      .getUpdateRecordsByShiftClosureAndArea(this.shiftClosureId, [Constants.GENERAL], true)
      .pipe(
        catchError(error => {
          console.error(`Error al cargar los datos para el area ${Constants.GENERAL}:`, error);
          return of([]);
        })
      );

    const areas$ = this.updateRecordService
      .getUpdateRecordsByShiftClosureAndArea(this.shiftClosureId, [
        Constants.CLORURO_FERRICO,
        Constants.SALMUERA_I,
        Constants.SALMUERA_II,
        Constants.COMPRESION,
        Constants.ELECTROLIZADORES,
        Constants.SUBESTACION,
        Constants.MOVIMIENTO_PRODUCTO,
        Constants.DCS,
      ], true)
      .pipe(
        catchError(error => {
          console.error('Error al cargar los datos de las áreas:', error);
          return of([]);
        })
      );

    const areaByType = this.type == 'turno_diario' ? Constants.AREA_CIERRE_TURNO_DIARIO : Constants.AREA_CIERRE_TURNO;
    const updateRecordsReport$ = this.updateRecordService.getUpdateRecordsByShiftClosureAndArea(this.shiftClosureId, [areaByType]).pipe(
      catchError(error => {
        console.error(`Error al cargar los datos para el area ${Constants.GENERAL}:`, error);
        return of(null);
      })
    );

    const shiftClosure$ = this.shiftClosureService.getShiftClosureById(this.shiftClosureId).pipe(
      catchError(error => {
        console.error(`Error al obtener cierre de turno con id ${this.shiftClosureId}:`, error);
        return of(null);
      })
    );


    forkJoin([general$, areas$, shiftClosure$]).subscribe(([generalData, areasData, shiftClosure]) => {
      // General: usar flatten estilo Shift Report y separar Seguridad/Personal
      const flattenedGeneral = this.flattenData(generalData);
      this.shiftUpdates = flattenedGeneral.length ? flattenedGeneral : [];
      this.filterDataByType();

      // Áreas: agrupar por tipo y llenar flattenedData como Shift Report
      const updatesByType = (areasData as UpdateRecord[]).reduce((acc, record) => {
        const typeCode = record.updateType?.code ?? 'DESCONOCIDO';
        if (!acc[typeCode]) acc[typeCode] = [];
        acc[typeCode].push(record);
        return acc;
      }, {} as Record<string, UpdateRecord[]>);

      let allFlattened: any[] = [];
      for (const [typeCode, group] of Object.entries(updatesByType)) {
        const flattened = this.flattenData(group);
        if (typeCode === Constants.NOVEDADES) this.groupDataByArea(flattened)
        this.flattenedData[typeCode] = flattened;
        allFlattened = allFlattened.concat(flattened);
      }
      this.shiftUpdatesByArea = allFlattened;

      if (shiftClosure) {
        this.hasShiftReport = shiftClosure.isReportAvailable;
        console.log('hasShiftReport establecido a:', this.hasShiftReport);
        console.log('Shift closure ID:', this.shiftClosureId, 'isReportAvailable:', shiftClosure.isReportAvailable);
      }

      // Preparar columnas readonly
      this.generalTableColumnsRO = this.toReadOnlyColumns(this.generalTableColumns);
      this.reportedBreakdownNoticeTableColumnsRO = this.toReadOnlyColumns(this.reportedBreakdownNoticeTableColumns);
      this.workOrderTableColumnsRO = this.toReadOnlyColumns(this.workOrderTableColumns);
      this.outOfServiceTableColumnsRO = this.toReadOnlyColumns(this.outOfServiceTableColumns);
      this.shiftUpdatesTableColumnsRO = this.toReadOnlyColumns(this.shiftUpdatesTableColumns);

      this.cdr.detectChanges();
    });
  }

  // Determina la marca de cierre a mostrar según el ROL del usuario
  // - jefeturno: usa isMarkedForClosure
  // - dcs: usa isMarkedForClosureDCS (o Dcs)
  // - férrico y otros operadores: usa isMarkedForClosureFerrico
  private getRoleSpecificClosureMark(update: UpdateRecord): boolean {
    const u: any = update as any;
    const has = (role: string) => this.authService?.hasRole?.(role);
    const isDcs = !!(has('Novedades_Operador_DCS') || has('DCS') || has('dcs'));
    const isFerricoOrOthers = !!(
      has('Novedades_Operador_Ferrico') ||
      has('Novedades_Salmuera_I') ||
      has('Novedades_Salmuera_II') ||
      has('Novedades_Compresion') ||
      has('Novedades_Electrolizadores') ||
      has('Novedades_Subestacion') ||
      has('Novedades_Movimiento_Producto') ||
      has('FERRICO') ||
      has('ferrico')
    );

    if (isDcs) {
      return (u.isMarkedForClosureDcs ?? u.isMarkedForClosureDCS ?? u.isMarkedForClosure) as boolean;
    }
    if (isFerricoOrOthers) {
      return (u.isMarkedForClosureFerrico ?? u.isMarkedForClosure) as boolean;
    }
    // jefeturno y demás: estándar
    return (u.isMarkedForClosure as boolean);
  }

  private toReadOnlyColumns(cols: TableColumn[]): TableColumn[] {
    return cols.filter(c => !c.isCheckbox);
  }

  private filterDataByType(): void {
    this.seguridadCalidadMedioAmbiente = this.shiftUpdates.filter(item =>
      item.updateType?.name?.toLowerCase().includes('seguridad') ||
      item.updateType?.name?.toLowerCase().includes('calidad') ||
      item.updateType?.name?.toLowerCase().includes('medio ambiente')
    );
    this.personalData = this.shiftUpdates.filter(item =>
      item.updateType?.name?.toLowerCase() === 'personal'
    );
  }

  flattenData(updates: UpdateRecord[]): any[] {
    return updates.flatMap(update => {
      const elements = update.updateElements;
      const getElementValue = (label: string): string =>
        elements.find(el => el.label === label)?.updateValues?.[0]?.value || '';
      const createdByUser = elements?.find(el => el.element?.id === 2 || el.element?.id === 5)
        ?.updateValues?.[0]?.createdUser;
      const responsibleId = (update as any)?.responsible?.id ?? createdByUser?.id ?? null;

      const hora = getElementValue('Hora');
      const novedad = getElementValue('Novedad');
      const tipoNovedad = getElementValue('Tipo de Novedad');
      const prioridad = getElementValue('Prioridad');
      const queEstaMal = getElementValue('¿Qué está mal?');
      const queTieneDeMalo = getElementValue('¿Qué tiene de malo?');
      const deberia = getElementValue('Debería');
      const nOrden = getElementValue('N° Orden de Trabajo');
      const horaInicio = getElementValue('Hora Inicio');
      const horaTermino = getElementValue('Hora Término');
      const horaPermiso = getElementValue('Hora Permiso Otorgado');
      const enEjecucion = getElementValue('En Ejecución');
      const comentarios = getElementValue('Comentarios');
      const horaFueraServicio = getElementValue('Hora Fuera de Servicio');
      const ingreseNovedad = getElementValue('Ingrese Novedad');

      const detalleNovedad = elements
        .filter(el => el.label !== 'Hora' && el.label !== 'Tipo de Novedad')
        .map(el => el.updateValues?.map(val => val.value).join(', ') || '')
        .filter(txt => txt.trim() !== '')
        .join(', ');

      return {
        id: update.id,
        hora,
        hora_inicio: horaInicio,
        hora_termino: horaTermino,
        hora_permiso: horaPermiso,
        hora_fuera_servicio: horaFueraServicio,
        ingrese_novedad: ingreseNovedad,
        en_ejecucion: enEjecucion === "true" ? "Si" : "No",
        n_orden: nOrden,
        prioridad,
        que_esta_mal: queEstaMal,
        que_tiene_de_malo: queTieneDeMalo,
        deberia,
        responsable: elements.find(el => el.element?.id === 2 || el.element?.id === 5)?.updateValues?.[0]?.createdUser?.username || '',
        createdById: createdByUser?.id ?? elements?.[0]?.updateValues?.[0]?.createdUser?.id ?? null,
        responsibleId,
        tipo_novedad: tipoNovedad ? tipoNovedad : update.updateType?.name,
        tipo: update.updateType?.name,
        area: update.updateArea?.name,
        updateArea: update.updateArea?.name,
        novedad: novedad,
        detalleNovedad,
        comentarios,
        fecha: elements.find(el => el.element?.id === 2 || el.element?.id === 5)?.updateValues?.[0]?.createdUtc || '',
        updateElements: elements,
        updateType: update.updateType,
        isMarkedForClosure: this.getRoleSpecificClosureMark(update),
        isCloned: update.isCloned,
      };
    });
  }

  canDelete(item: any): boolean {
    const uid = this.authService.getUserId();
    if (!uid) return false;
    if (typeof item?.responsibleId === 'number') {
      return item.responsibleId === uid;
    }
    return item?.createdById === uid;
  }

  canEdit(item: any): boolean {
    // Editar: Novedades global o Férrico en vista Cloruro Férrico
    return this.authService.hasRole('novedades')
  }

  newUpdateRecord(type: string, area: string): void {
    if (!this.shiftClosureId) {
      console.error('No se puede crear: shiftClosureId no válido');
      return;
    }
    const dialogRef = this.dialog.open(ModalComponent, {
      data: { type, area, shiftClosureId: this.shiftClosureId, saveOnlyUpdateRecord: true },
      width: '600px',
    });
    dialogRef.afterClosed().subscribe((result: { success: boolean }) => {
      if (result?.success) {
        this.loadData();
      }
    });
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  viewUpdateRecord(updateRecord: UpdateRecord): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: updateRecord,
        readOnly: true,
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  editUpdateRecord(updateRecord: any): void {
    if (!updateRecord.updateElements) {
      console.error('El objeto no tiene elementos de actualización:', updateRecord);
      return;
    }

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: updateRecord, // Pasar los datos del registro
        readOnly: false, // Permitir edición
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result: { success: boolean }) => {
      if (result?.success) {
        console.log('Edición realizada con éxito. Actualizando datos...');
        this.ngOnInit();
      }
    });
  }

  deleteUpdateRecord(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: '¿Estás seguro de que deseas eliminar este registro?' },
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.updateRecordService.deleteUpdateRecord(id).subscribe({
          next: () => {
            console.log(`Registro con ID ${id} eliminado correctamente.`);
            this.ngOnInit();
          },
          error: error => {
            console.error(`Error al eliminar el registro con ID ${id}:`, error);
          },
        });
      }
    });
  }

  async shiftClosure() {
    const res = this.authService.getCurrentUser()
    const isBoss = res.roles[0] == 'novedades'
    const type = this.type == Constants.TURNO_DIARIO ? Constants.TIPO_CIERRE_TURNO : Constants.TIPO_CIERE_TURNO_INFORME_DIARIO;
    const area = this.type == Constants.TURNO_DIARIO ? Constants.AREA_CIERRE_TURNO_DIARIO : Constants.AREA_CIERRE_TURNO;
    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        type: type,
        area: area,
        saveOnlyUpdateRecord: true,
        shiftClosureId: this.shiftClosureId,
        isPreviewMode: false, // Desactivar previsualización automática - funciona como shift-closure
        isHistorical: true, // Marcar como histórico para omitir validación de turno abierto
        isBoss
      },
      width: '900px',
    });

    dialogRef.afterClosed().subscribe((result: { success: boolean, navigateToHistoricalShift?: boolean, error?: any } | undefined) => {
      if (result?.success) {
        console.log('Modal cerrado con éxito. Actualizando disponibilidad del reporte...');
        // Llamada específica para actualizar la disponibilidad del reporte para este turno histórico
        this.updateReportAvailability();

        // Si el modal indica que debe navegar a historical-shift, hacerlo después de un breve delay
        if (result.navigateToHistoricalShift) {
          setTimeout(() => {
            console.log('Navegando a historical-shift...');
            this.router.navigate(['/historical-shift']);
          }, 1500); // Delay para permitir que se complete la actualización del reporte
        }
      } else {
        console.log('Modal cerrado sin acción.');
      }
      this.loadData();
    });
  }

  shiftClosureNotBoss(){

  }
  /**
   * Actualiza la disponibilidad del reporte para el turno histórico específico
   */
  private updateReportAvailability(): void {
    if (!this.shiftClosureId) {
      console.error('No se puede actualizar la disponibilidad del reporte: shiftClosureId no válido');
      return;
    }

    this.shiftClosureService.updateReportAvailability(this.shiftClosureId, true).subscribe({
      next: () => {
        console.log(`Disponibilidad del reporte actualizada para turno ${this.shiftClosureId}`);
        // Actualizar el estado local
        this.hasShiftReport = true;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error al actualizar la disponibilidad del reporte:', error);
        this.snackBar.open('Error al actualizar la disponibilidad del reporte.', 'Cerrar', { duration: 3000 });
      }
    });
  }

  onCheckboxChange(isMarked: boolean, updateRecordId: number): void {


    // Daily-shift: actualizar la marca de cierre diario
    this.updateRecordService.updateMarkForClosure(updateRecordId, isMarked).subscribe({
      next: () => {
        console.log('Estado actualizado correctamente.');
      },
      error: (error) => {
        console.error('Error al actualizar el estado:', error);
      },
    });
  }
  

  // Manejo de selección individual de checkbox para marcar para cierre
  onCheckboxChangeForClosure(isMarked: boolean, updateRecordId: number): void {

    console.log(`Marcando registro ${updateRecordId} para cierre: ${isMarked}`);

    const dataArrays = [
      this.shiftUpdates,
      this.shiftUpdatesByArea,
      this.seguridadCalidadMedioAmbiente,
      this.personalData,
      ...Object.values(this.flattenedData)
    ];
    let targetItem: any = null;

    for (const dataArray of dataArrays) {
      targetItem = dataArray.find(item => item.id === updateRecordId);
      if (targetItem) break;
    }

    if (targetItem) {
      const previousState = targetItem.isMarkedForClosure;
      targetItem.isMarkedForClosure = isMarked; // Actualizar optimistamente la UI

      this.updateRecordService.updateMarkForClosure(updateRecordId, isMarked).subscribe({
        next: () => {
          console.log('Estado actualizado correctamente.');
        },
        error: (error) => {
          console.error('Error al actualizar el estado:', error);
          // Revertir el estado de la UI en caso de error
          targetItem.isMarkedForClosure = previousState;
          this.snackBar.open('Error al actualizar el estado', 'Cerrar', { duration: 3000 });
        },
      });
    }
  }

  // Manejo de selección masiva (select all)
  onSelectAllChange(event: { checked: boolean; type: string; visibleData?: any[] }): void {
    const isChecked = event.checked;
    const tableType = event.type;

    console.log(`Select all para tabla ${tableType}: ${isChecked}`);

    let dataArray: any[] = [];

    // Si se proporcionan los datos visibles, usar esos. Si no, usar todos los datos.
    if (event.visibleData && event.visibleData.length > 0) {
      dataArray = event.visibleData;
    } else {
      // Determinar qué array de datos actualizar según el tipo de tabla
      switch (tableType) {
        case 'shiftUpdates':
          dataArray = this.shiftUpdates || [];
          break;
        case 'shiftUpdatesByArea':
          dataArray = this.shiftUpdatesByArea || [];
          break;
        default:
          console.warn('Tipo de tabla no reconocido:', tableType);
          return;
      }
    }

    // Si no hay datos, salir
    if (!dataArray || dataArray.length === 0) {
      console.warn('No hay datos para actualizar en el tipo de tabla:', tableType);
      return;
    }

    // Filtrar solo los elementos que realmente necesitan cambio de estado
    const itemsToUpdate = dataArray.filter((item: any) => {
      return item && item.id && item.isMarkedForClosure !== isChecked;
    });

    if (itemsToUpdate.length === 0) {
      console.log('Todos los elementos visibles ya tienen el estado deseado.');
      return;
    }

    console.log(`Actualizando ${itemsToUpdate.length} registros en la tabla ${tableType}`);

    // Almacenar estados anteriores para posible reversión (solo para elementos que van a cambiar)
    const previousStates = itemsToUpdate.map(item => ({
      id: item.id,
      isMarkedForClosure: item.isMarkedForClosure
    }));

    // Actualizar visualmente solo los elementos que van a cambiar
    itemsToUpdate.forEach((item: any) => {
      item.isMarkedForClosure = isChecked;
    });

    // Realizar las llamadas a la API solo para los elementos que cambiaron
    const requests = itemsToUpdate.map((item: any) =>
      this.updateRecordService.updateMarkForClosure(item.id, isChecked)
    );

    // Usar forkJoin para manejar múltiples solicitudes en paralelo
    forkJoin(requests).subscribe({
      next: () => {
        console.log(`Se actualizaron ${requests.length} registros visibles correctamente en la tabla ${tableType}.`);
      },
      error: (error) => {
        console.error('Error al actualizar algunos registros:', error);

        // En caso de error, revertir los cambios visuales solo en los elementos que se intentaron cambiar
        previousStates.forEach(prevState => {
          const item = itemsToUpdate.find(dataItem => dataItem.id === prevState.id);
          if (item) {
            item.isMarkedForClosure = prevState.isMarkedForClosure;
          }
        });
      }
    });
  }

  /**
   * Abre la previsualización PDF para el turno histórico
   */
  async openPdfPreview() {
    try {
      if (!this.shiftClosureId) {
        this.snackBar.open('No se encontró un turno válido para previsualizar.', 'Cerrar', { duration: 3000 });
        return;
      }

      // Cargar los datos actuales del turno histórico
      const currentFormValues = await this.getCurrentFormValues(this.shiftClosureId);

      // Determinar el tipo y área basándose en el type del turno histórico
      const modalType = this.type === 'turno_diario' ?
        Constants.TIPO_CIERRE_TURNO :
        Constants.TIPO_CIERE_TURNO_INFORME_DIARIO;

      const modalArea = this.type === 'turno_diario' ?
        Constants.AREA_CIERRE_TURNO_DIARIO :
        Constants.AREA_CIERRE_TURNO;

      // Abrir el modal con el flujo de stepper
      const dialogRef = this.dialog.open(ModalComponent, {
        data: {
          type: modalType,
          area: modalArea,
          readOnly: true, // Solo lectura para turnos históricos
          shiftClosureId: this.shiftClosureId,
          isPreviewMode: true, // Modo previsualización automática
          currentFormValues: currentFormValues // Pasar los valores del turno histórico
        },
        minWidth: '50%',
        minHeight: '20%',
        maxWidth: '1200px',
        disableClose: true
      });

      dialogRef.afterClosed().subscribe((result) => {
        // Para turnos históricos, no necesitamos recargar datos
        console.log('Modal de previsualización cerrado:', result);
      });
    } catch (error) {
      console.error('Error al abrir la previsualización PDF:', error);
      this.snackBar.open('Error al obtener los datos del turno histórico.', 'Cerrar', { duration: 3000 });
    }
  }

  /**
   * Obtiene los valores actuales del formulario para el turno histórico especificado
   */
  async getCurrentFormValues(shiftClosureId: number): Promise<any> {
    try {
      // Determinar el área correcta basándose en el type
      const areaByType = this.type === 'turno_diario' ?
        Constants.AREA_CIERRE_TURNO_DIARIO :
        Constants.AREA_CIERRE_TURNO;

      // Obtener los datos del registro histórico
      const records = await lastValueFrom(
        this.updateRecordService.getUpdateRecordsByShiftClosureAndArea(
          shiftClosureId,
          [areaByType],
          true
        )
      );

      if (records && records.length > 0) {
        // Transformar los datos a un formato que pueda ser utilizado por el formulario
        const formValues: { [key: string]: any } = {};

        // Procesar cada elemento del registro y guardar sus valores
        records[0].updateElements.forEach(element => {
          if (element.updateValues && element.updateValues.length > 0) {
            const value = element.updateValues[0].value;
            // Solo guardar valores que no sean '0' o vacíos
            if (value !== '0' && value !== '') {
              formValues[element.id.toString()] = value;
              console.log(`Cargando valor del formulario para campo ${element.id}: ${value}`);
            }
          }
        });

        return formValues;
      }

      return {}; // Retornar objeto vacío si no hay datos
    } catch (error) {
      console.error('Error al obtener los valores del formulario del turno histórico:', error);
      return {};
    }
  }


  // Método para agrupar datos por área
  groupDataByArea(data: any[]): void {
    // Mapeo de códigos de área a nombres para mostrar
    const areaDisplayNames: { [key: string]: string } = {
      [Constants.CLORURO_FERRICO]: 'Cloruro Férrico',
      [Constants.SALMUERA_I]: 'Salmuera I',
      [Constants.SALMUERA_II]: 'Salmuera II',
      [Constants.COMPRESION]: 'Compresión',
      [Constants.ELECTROLIZADORES]: 'Electrolizadores',
      [Constants.SUBESTACION]: 'Subestación',
      [Constants.MOVIMIENTO_PRODUCTO]: 'Movimiento de productos',
      [Constants.DCS]: 'DCS',
      'Personal': 'Personal',
      'Seguridad / Calidad / Medio Ambiente': 'Seguridad / Calidad / Medio Ambiente'
    };

    // Función para normalizar texto (quitar tildes, convertir a minúsculas, quitar espacios extra)
    const normalizeText = (text: string): string => {
      return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Quitar tildes
        .replace(/\s+/g, ' ')
        .trim();
    };

    // Mapeo completo de todas las posibles variaciones de nombres de área a nombres finales
    const createAreaMapping = (): { [key: string]: string } => {
      const mapping: { [key: string]: string } = {};

      // Cloruro Férrico - todas las variaciones posibles
      const cloruroVariations = [
        'Cloruro Férrico', 'Cloruro Ferrico', 'cloruro férrico', 'cloruro ferrico',
        'CLORURO FÉRRICO', 'CLORURO FERRICO', 'Cloruro_Ferrico', 'cloruro_ferrico'
      ];
      cloruroVariations.forEach(v => mapping[normalizeText(v)] = 'Cloruro Férrico');

      // Salmuera I - todas las variaciones posibles
      const salmueraIVariations = [
        'Salmuera I', 'salmuera i', 'SALMUERA I', 'Salmuera_I', 'salmuera_i',
        'Salmuera 1', 'salmuera 1', 'SALMUERA 1'
      ];
      salmueraIVariations.forEach(v => mapping[normalizeText(v)] = 'Salmuera I');

      // Salmuera II - todas las variaciones posibles  
      const salmueraIIVariations = [
        'Salmuera II', 'salmuera ii', 'SALMUERA II', 'Salmuera_II', 'salmuera_ii',
        'Salmuera 2', 'salmuera 2', 'SALMUERA 2'
      ];
      salmueraIIVariations.forEach(v => mapping[normalizeText(v)] = 'Salmuera II');

      // Compresión - todas las variaciones posibles
      const compresionVariations = [
        'Compresión', 'Compresion', 'compresión', 'compresion',
        'COMPRESIÓN', 'COMPRESION', 'Compresion', 'compresion'
      ];
      compresionVariations.forEach(v => mapping[normalizeText(v)] = 'Compresión');

      // Electrolizadores - todas las variaciones posibles
      const electrolizadoresVariations = [
        'Electrolizadores', 'electrolizadores', 'ELECTROLIZADORES',
        'Electrolizador', 'electrolizador', 'ELECTROLIZADOR'
      ];
      electrolizadoresVariations.forEach(v => mapping[normalizeText(v)] = 'Electrolizadores');

      // Subestación - todas las variaciones posibles
      const subestacionVariations = [
        'Subestación', 'Subestacion', 'subestación', 'subestacion',
        'SUBESTACIÓN', 'SUBESTACION'
      ];
      subestacionVariations.forEach(v => mapping[normalizeText(v)] = 'Subestación');

      // Movimiento de productos - todas las variaciones posibles
      const movimientoVariations = [
        'Movimiento de productos', 'movimiento de productos', 'MOVIMIENTO DE PRODUCTOS',
        'Movimiento de Productos', 'Movimiento_de_productos', 'movimiento_de_productos',
        'Movimiento', 'movimiento', 'MOVIMIENTO'
      ];
      movimientoVariations.forEach(v => mapping[normalizeText(v)] = 'Movimiento de productos');

      // DCS - todas las variaciones posibles
      const dcsVariations = ['DCS', 'dcs', 'Dcs'];
      dcsVariations.forEach(v => mapping[normalizeText(v)] = 'DCS');

      // Personal - todas las variaciones posibles
      const personalVariations = ['Personal', 'personal', 'PERSONAL'];
      personalVariations.forEach(v => mapping[normalizeText(v)] = 'Personal');

      // General / Seguridad / Calidad / Medio Ambiente - todas las variaciones posibles
      const generalVariations = [
        'General', 'general', 'GENERAL',
        'Seguridad / Calidad / Medio Ambiente', 'seguridad / calidad / medio ambiente',
        'Seguridad', 'seguridad', 'SEGURIDAD',
        'Calidad', 'calidad', 'CALIDAD',
        'Medio Ambiente', 'medio ambiente', 'MEDIO AMBIENTE'
      ];
      generalVariations.forEach(v => mapping[normalizeText(v)] = 'Seguridad / Calidad / Medio Ambiente');

      return mapping;
    };

    const areaMapping = createAreaMapping();

    // Inicializar todas las áreas con arrays vacíos
    this.groupedGeneralData = {};
    Object.values(areaDisplayNames).forEach(displayName => {
      this.groupedGeneralData[displayName] = [];
    });

    // Agrupar los datos existentes
    data.forEach(item => {
      let areaKey = item.updateArea || 'Sin área';
      //console.log('Procesando item con área:', areaKey, 'Item completo:', item);

      // Normalizar el nombre del área para comparación
      const normalizedAreaKey = normalizeText(areaKey);

      // Buscar el mapeo en nuestra tabla de mapeo completa
      let displayName = areaMapping[normalizedAreaKey];

      // Si no se encuentra una coincidencia exacta, usar valor por defecto
      if (!displayName) {
        console.warn('Área no reconocida:', areaKey, 'normalizada como:', normalizedAreaKey);
        displayName = 'Seguridad / Calidad / Medio Ambiente'; // Área por defecto
      }

      //console.log('Área mapeada:', areaKey, '->', displayName);

      if (!this.groupedGeneralData[displayName]) {
        this.groupedGeneralData[displayName] = [];
      }

      this.groupedGeneralData[displayName].push(item);
    });

    // Definir el orden de las áreas (Personal y Seguridad al final)
    this.areaNames = Object.keys(areaDisplayNames).filter(key => key !== 'Personal' && key !== 'Seguridad / Calidad / Medio Ambiente')
      .map(key => areaDisplayNames[key])
      .sort((a, b) => a.localeCompare(b));

    // console.log('Datos agrupados por área:', this.groupedGeneralData);
    // console.log('Nombres de áreas:', this.areaNames);
  }

}

